import { FC } from 'react'

import { CircularProgress, Stack, Typography } from '@mui/material'

import { COMPETITIONS_LIST_MIN_HEIGHT } from './constants'

type LoadingCompetitionsStateProps = {
  isAutoLoading?: boolean
}

export const LoadingCompetitionsState: FC<LoadingCompetitionsStateProps> = ({
  isAutoLoading = false
}) => {
  return (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{
        height: '100%',
        minHeight: COMPETITIONS_LIST_MIN_HEIGHT
      }}
    >
      <CircularProgress />
      {isAutoLoading && (
        <Typography variant="body2" sx={{ ml: 2 }}>
          Loading more competitions...
        </Typography>
      )}
    </Stack>
  )
}
